import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import Cookies from "js-cookie";
import "./InboxConfirming.scss";
import {ePismoClientInstance} from "../Service/EPismoClient";
import {useKeycloak} from "@react-keycloak/web";


export default function InboxConfirming({
                                            onDeclineAdditionalAction = () => {},
                                            force = false
                                        }) {
    const [open, setOpen] = useState(false);
    const [userActive, setUserActive] = useState(true);
    const keycloak = useKeycloak();

    const cookieName = "INBOX_ACCEPTED";
    const onAccept = () => {
        ePismoClientInstance.post("/v1/gui/user/active", keycloak, {})
            .catch(e => alert("Błąd poczas aktywacji skrzynki odbiorczej"));
    };
    const onDecline = () => {
        onDeclineAdditionalAction();
    };

    useEffect(() => {
        const cookieValue = Cookies.get(cookieName);
        if ((!cookieValue || force) && !userActive) {
            setOpen(true);
        }
    }, [cookieName, userActive]);

    useEffect(() => {
        ePismoClientInstance.get("/v1/gui/user/active", keycloak)
            .then(resp => setUserActive(resp.data))
            .catch(e => alert("Błąd poczas aktywacji skrzynki odbiorczej"));
    }, [cookieName]);

    const handleAccept = () => {
        // Set the cookie to indicate the user accepted
        Cookies.set(cookieName, "accepted", { expires: 30 }); // Cookie valid for 30 days
        setOpen(false);
        if (onAccept) onAccept(); // Trigger the provided callback
    };

    const handleDecline = () => {
        // Set the cookie to indicate the user declined
        Cookies.set(cookieName, "declined", { expires: 7 }); // Cookie valid for 30 days
        setOpen(false);
        if (onDecline) onDecline(); // Trigger the provided callback
    };

    return (
        <Dialog open={open} onClose={handleDecline} className="InboxCofirmingDialog">
            <DialogTitle sx={{textAlign:"center"}}>Szanowny Użytkowniku,</DialogTitle>
            <DialogContent sx={{textAlign:"center"}}>
                <p>Informujemy, że pojawiła się nowa aktualizacja systemu, która wprowadza wewnętrzną skrzynkę pocztową. Dzięki niej Twoja komunikacja stanie się bezpieczniejsza i wygodniejsza.</p>

                <p><b>Wewnętrzna skrzynka odbiorcza zapewnia najwyższy poziom bezpieczeństwa komunikacji, dlatego zaleca
                    się jej uruchomienie.</b></p>

                <p>Możesz właczyć skrzynkę pocztową w dogodnym momencie w zakładce „Skrzynka pocztowa”.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAccept} color="primary">
                    Tak, chcę używac skrzynki odbiorczej
                </Button>
                <Button onClick={handleDecline} color="secondary">
                    Nie chcę używać skrzynki odbiorczej
                </Button>
            </DialogActions>
        </Dialog>
    );
};

